import { render, staticRenderFns } from "./shirt2.vue?vue&type=template&id=ff7793e6&"
import script from "./shirt2.vue?vue&type=script&lang=js&"
export * from "./shirt2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports